import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tourParticipantCustomFieldsApi from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.ts';
import { tourParticipantCustomFieldsApiQueryKeys } from '@/features/dashboard/tourCustomFields/api/tourParticipantCustomFieldsApi.queryKeys.ts';

const useDeleteCustomField = (tourId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (fieldId) =>
      tourParticipantCustomFieldsApi.deleteField(tourId, fieldId),
    onSuccess: () => {
      toast.success('Pole zostało usunięte');
      queryClient.invalidateQueries({
        queryKey: tourParticipantCustomFieldsApiQueryKeys.allForTour(tourId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się usunąć pola', {
        description: error.message,
      });
    },
  });
};

export default useDeleteCustomField;
